const CONSTANTS: { DEV: boolean } = {
    // @ts-expect-error - this is a vite thing
    DEV: import.meta.env.DEV
};
export default CONSTANTS;